import { useContext } from 'react';
import { ToastsContext, ToastsContextType } from '../contexts';

export const useToastsContext = (): ToastsContextType => useContext(ToastsContext);
